import { accountIdFormat } from "@redotech/redo-account-id";
import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const ProductFamilySearchProductSchema_ = z.object({
  id: productIdFormat.schema,
  title: z.string(),
  sku: z.string().nullable(),
  imageUrl: z.string().nullable(),
});
export const ProductFamilySearchProductSchema: z.ZodType<ProductFamilySearchProduct> =
  ProductFamilySearchProductSchema_;
export interface ProductFamilySearchProduct extends z.infer<
  typeof ProductFamilySearchProductSchema_
> {}

const ProductFamilySearchResultSchema_ = z.object({
  id: productFamilyIdFormat.schema,
  title: z.string(),
  imageUrl: z.string().nullable(),
  products: z.array(ProductFamilySearchProductSchema_),
});
export const ProductFamilySearchResultSchema: z.ZodType<ProductFamilySearchResult> =
  ProductFamilySearchResultSchema_;
export interface ProductFamilySearchResult extends z.infer<
  typeof ProductFamilySearchResultSchema_
> {}

export const searchProductFamilies = unaryRpc({
  name: "searchProductFamilies" as const,
  input: z.object({
    accountId: accountIdFormat.schema,
    query: z.string(),
    limit: z.number().min(1).max(50),
  }),
  output: z.object({ families: z.array(ProductFamilySearchResultSchema) }),
});
